import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSetting = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9 13H7v7H5v-7H3v-2h6zm4 7h-2v-9h2zm8-3h-2v3h-2v-3h-2v-2h6zm-2-4h-2V4h2zM7 9H5V4h2zm6-2h2v2H9V7h2V4h2z" })
});
export default SvgSetting;
